import { Image } from "@chakra-ui/react";
import { ImageProps } from "@chakra-ui/image/dist/types/image";

import { ColorMode, useConfigurationThemeConsumer } from "ChakraTheme";

interface IProps extends Omit<ImageProps, "src"> {
  lightImage: string;
  darkImage: string;
}

const UndrawImage = ({ darkImage, lightImage, ...restProps }: IProps) => {
  const { theme } = useConfigurationThemeConsumer();

  return (
    <Image
      maxH="400px"
      src={theme.mode === ColorMode.Light ? lightImage : darkImage}
      {...restProps}
    />
  );
};

export { UndrawImage };
